<template>
<div>
  <v-app-bar color="blue accent-1" >
      <v-app-bar-nav-icon color="white" @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">Hana's English</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn outlined small>Login</v-btn> -->
  </v-app-bar>
    <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    >
      <sideBar @setSubCategory="setSubCategory"/>
    </v-navigation-drawer>
  <v-container>
    <v-card class="pa-2">
      <v-card-title>
        공지사항
      </v-card-title>
      <v-list>
          <v-divider  class="mx-2" />
          <div v-for="notice in notices" :key="notices.id">
            <v-list-item>
              <v-list-item-content @click="setNoticeView(notice)">
                <v-list-item-title>
                  {{notice.title}}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                 <v-chip class="grey--text text-capitalize ml-1"
                text
                outlined
                @click="copyNoticeUrl(notice)"
                >URL 복사</v-chip>
              </v-list-item-action>
              <v-list-item-action>
                <v-list-item-subtitle>
                  {{ formatDate(notice.created_at) }}
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          <v-divider  class="mx-2" />
        </div>
      </v-list>
      <div class="text-center mt-2">
        <v-pagination
          v-model="page"
          :length="10"
          circle
        ></v-pagination>
      </div>
    </v-card>
  </v-container>

   <!-- 로딩 중일 때 보여질 내용 -->
   <v-overlay :value="loading">
     <v-progress-circular
        indeterminate
        color="primary"
     ></v-progress-circular>
   </v-overlay>
  
          <!--URL Copy-->
        <v-dialog v-model="copied" max-width="300px">
                <v-card><v-card-title>URL를 복사하였습니다.
                <v-btn outlined block @click="copied=!copied">닫기</v-btn>
                        </v-card-title></v-card>
        </v-dialog>

  <v-dialog v-model="show_notice_view" max-width="800px" max-height="1200px" >
    <v-card>
    <v-card-title><v-btn outlined block @click="show_notice_view=!show_notice_view"  class="green--text"  >닫기</v-btn></v-card-title>
        <v-card-text>
        <v-row>
                <v-col cols="12">
                        <div v-html="noticeContentQuill"></div>
                </v-col>
        </v-row>
      	</v-card-text>

	<div v-for="(image, index) in selected_notice.images" :key="index" > 
	<v-img :src="$store.state.backend_url+image.image"  style="width: 100%; hegiht:auto;">
	</v-img>
</div>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined block @click="show_notice_view=!show_notice_view"  class="green--text" >
          닫기 
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
  import sideBar from '@/components/sideBar.vue'
  import axios from 'axios'

  export default {
    data: () => ({
      drawer: false,
      show_notice_view: false,
      page: 1,

      category_title: 'Total',
      sub_category : {},
      sub_category_id : 0,

      notices : [],
      selected_notice: {},
      selected_notice_id : null,
      copied : false,
      loading: false,
 
    }),
    components: {
      sideBar,
    },

    mounted(){
     this.getNotice()
     const params = new URLSearchParams(window.location.search);
     this.selected_notice_id = params.get('selected_notice');
    },
    watch:{
      selected_notice_id(newProduct, oldProdcut){
          this.getSelectedNotice()
      },
    }, 
    methods:{
      setSubCategory(sub_category){
        this.drawer = false
        this.sub_category = sub_category
        this.sub_category_id = sub_category.id
        this.category_title = sub_category.name
      },

      getNotice(){
	this.loading = true;
        axios
        .get('api/userinfor/notice/')
        .then(res=>{
          this.notices = res.data
	  this.loading = false
        })
      },

      getSelectedNotice(){
       axios.get(`api/userinfor/notice-detail/${this.selected_notice_id}/`)
        .then(res=>{
           this.setNoticeView(res.data)
           console.log(res.data.image)
        })
        .catch(error => {
          console.error('요기', error);
        });
      }, 

      setNoticeView(notice){
        this.selected_notice = notice
        this.show_notice_view = true
      },

      copyNoticeUrl(notice) {
        navigator.clipboard.writeText(`https://hana-english.com/?selected_notice=${notice.id}`)
        .then(() => {
                this.copied = true; // 복사 성공 시 알림 표시
        })
        .catch((error) => {
          console.error('Failed to copy URL:', error);
        });
       }, 
      formatDate(dateTimeString) {
          if(dateTimeString==null){
          } else {
              const dateTime = new Date(dateTimeString);
              // const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              //const options = { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
	      const options = { month: 'numeric', day: 'numeric'};
              return dateTime.toLocaleString(undefined, options);
          }
	      },  
      },
      computed:{
        formattedDateTimes() {
          return this.dateTimeStrings.map((dateTimeString) => this.formatDate(dateTimeString));
          },
	noticeContentQuill() {
		if(this.selected_notice.description){
			let description_html = this.selected_notice.description
			description_html = description_html.replace('<img', '<img class="responsive-image" '); 
                	return description_html
		}
	},
      }
  }
</script>
<style scoped>
.a4-carousel {
  width: 794px; /* A4 width in pixels */
  height: 1123px; /* A4 height in pixels */
  margin: 0 auto; /* 중앙 정렬 */
}
</style>
